import { styled, TableCell, tableCellClasses, TableContainer } from "@mui/material";

export const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: 0,
  height: "100%",

  "& td, & th": {
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
  },
}));

export const StyledTableHeadCell = styled(TableCell)(
  ({ theme: { spacing, palette } }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: palette.grey[50],
      textTransform: "none",
      "&:first-of-type": {
        paddingLeft: spacing(3),
      },
      "&:last-of-type": {
        paddingRight: spacing(3),
      },
      padding: `${spacing(1.5)} ${spacing(1)}`,
    },
  }),
);

export const StyledTableBodyCell = styled(TableCell)(({ theme: { spacing } }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    "&:first-of-type": {
      paddingLeft: spacing(3),
    },
    "&:last-of-type": {
      paddingRight: spacing(3),
    },
    padding: spacing(1),
    lineBreak: "anywhere",
  },
  [`& .MuiSvgIcon-fontSizeSmall`]: {
    fontSize: 16,
  },
}));
